export default __webpack_public_path__ + "static/media/star.ed701c7c.png";